<template>
  <div id="content">
    <form>
      <div class="inner">
        <h1>{{ formData.hostname }}</h1>
      </div>
      <tabs-wrapper>
        <tabs-content>
          <section>
            <div class="left">
              <h2 v-translate>Protokoly</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <p class="field checkbox_label" v-translate>Lineární</p>
                <div class="field checkboxes">
                  <filter-checkbox
                      v-for="protocolId in formData.linear_protocol_ids"
                      :key="protocolId"
                      :id="'linear-' + protocolId"
                      :name="protocolNames[protocolId]"
                      :val="protocolId"
                      v-model="linearProtocolIds">{{ protocolNames[protocolId] }}
                  </filter-checkbox>
                </div>
              </div>
              <div class="field_right">
                <p class="field checkbox_label" v-translate>Nelineární</p>
                <div class="field checkboxes">
                  <filter-checkbox
                      v-for="protocolId in formData.nonlinear_protocol_ids"
                      :key="protocolId"
                      :id="'nonlinear' + protocolId"
                      :name="protocolNames[protocolId]"
                      :val="protocolId"
                      v-model="nonlinearProtocolIds">{{ protocolNames[protocolId] }}
                  </filter-checkbox>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div class="left">
              <h2 v-translate>Profily kanálů</h2>
            </div>
            <div class="right checkbox_group">
              <ul class="settings">
                <list-checkbox-input
                    v-for="profile in formData.profiles"
                    :key="profile.id"
                    :id="profile.id"
                    group-id="stream"
                    :name="profile.name"
                    :selected-entities="streamProfileIds"
                    @input="toggleProfile"
                >
                  <span>({{ profile.code }}) </span>{{ profile.name }}
                </list-checkbox-input>
              </ul>
            </div>
          </section>

          <section>
            <div class="left">
              <h2 v-translate>
                Nastavení nelineárního obsahu pro jednotlivé kanály
              </h2>
            </div>
            <div class="right">
              <div class="field_left">
                <p class="field">
                  <input id="hastimeshift" name="hastimeshift" type="checkbox"
                         v-model="nonlinearSettings.has_timeshift"
                         :disabled="!nonlinearSettingsEnabled">
                  <label for="hastimeshift"
                         :class="{disabled: !nonlinearSettingsEnabled}"
                         v-translate>Max. délka TimeShiftu</label>
                  <input id="timeshiftoverride" name="timeshiftoverride" size="30" type="number"
                         v-model="nonlinearSettings.timeshift_override"
                         :disabled="!nonlinearSettings.has_timeshift || !nonlinearSettingsEnabled">
                </p>
                <p class="field">
                  <input id="hascatchup" name="hascatchup" type="checkbox"
                         v-model="nonlinearSettings.has_catchup"
                         :disabled="!nonlinearSettingsEnabled">
                  <label for="hascatchup"
                         :class="{disabled: !nonlinearSettingsEnabled}"
                         v-translate>Max. délka CatchUpu</label>
                  <input id="catchupoverride" name="catchupoverride" size="30" type="number"
                         v-model="nonlinearSettings.catchup_override"
                         :disabled="!nonlinearSettings.has_catchup || !nonlinearSettingsEnabled">
                </p>
              </div>
              <div class="field_right">
                <p class="field">
                  <input id="haspvr" name="haspvr" type="checkbox"
                         v-model="nonlinearSettings.has_pvr"
                         :disabled="!nonlinearSettingsEnabled">
                  <label for="haspvr"
                         :class="{disabled: !nonlinearSettingsEnabled}"
                         v-translate>Max. délka uložení nahrávek</label>
                  <input id="pvroverride" name="pvroverride" size="30" type="number"
                         v-model="nonlinearSettings.pvr_override"
                         :disabled="!nonlinearSettings.has_pvr || !nonlinearSettingsEnabled">
                </p>
              </div>
            </div>
          </section>

          <channel-checkbox-list-section
              :search-keys="['name', 'id']"
              :prepend-channel-id="true"
              :title="'Kanály' | translate"
              group-id="channels"
              :items="formData.channels"
              :selected-items="channels"
              @toggle-select="channels = arguments[0]"
          ></channel-checkbox-list-section>
          <section class="buttons">
            <p>
              <input
                  type="submit" :value="'Přidat kanály' | translate"
                     :class="['btn', {btn_inactive: !validFormData}]"
                     :disabled="!validFormData"
                     @click.stop.prevent="submit">
            </p>
          </section>
        </tabs-content>
      </tabs-wrapper>
    </form>
  </div>
</template>

<script>
import message from "@/components/mixins/message"
import TabsWrapper from "@/components/common/tabs/TabsWrapper"
import TabsContent from "@/components/common/tabs/TabsContent"
import ListCheckboxInput from "@/components/common/ListCheckboxInput"
import ChannelCheckboxListSection from "@/components/common/ChannelCheckboxListSection"
import {processCheckboxListToggle} from "@/utils/helpers"

export default {
  name: "ContentSourceContentNew",
  components: {
    ChannelCheckboxListSection,
    ListCheckboxInput,
    TabsContent,
    TabsWrapper
  },
  mixins: [message],
  data() {
    return {
      protocolNames: {},
      formData: {channels: []},
      linearProtocolIds: [],
      nonlinearProtocolIds: [],
      streamProfileIds: [],
      nonlinearSettings: {
        has_timeshift: false,
        has_catchup: false,
        has_pvr: false,
        timeshift_override: '',
        catchup_override: '',
        pvr_override: '',
      },
      search: '',
      channels: [],
    }
  },
  created(ContentSourceService, ProtocolService, ContentSourceContentService) {
    this.contentSourceService = ContentSourceService
    this.protocolService = ProtocolService
    this.contentSourceContentService = ContentSourceContentService;

    this.setLoadingMessage()
    this.contentSourceService.getNewContentFormData(this.$route.params.id)
        .then(data => {
          this.emptyMessage()
          this.formData = data['form_data']
        })
        .catch(error => {
          this.setErrorMessage(error['error_message'])
        })

    this.protocolService.getSimpleEntities()
        .then(data => {
          let protocolNames = {}
          this._.forEach(data['protocols'], (protocol) => {
            protocolNames[protocol.id] = protocol.name
          })
          this.protocolNames = protocolNames
        })
  },
  computed: {
    nonlinearSettingsEnabled() {
      return this.nonlinearProtocolIds.length > 0
    },
    validFormData() {
      let nonlinearSettingsValid = true
      if (this.nonlinearSettingsEnabled) {
        nonlinearSettingsValid = this.nonlinearSettings.has_timeshift === true ||
            this.nonlinearSettings.has_catchup === true ||
            this.nonlinearSettings.has_pvr === true
      }

      return this.streamProfileIds.length > 0 && this.channels.length > 0 &&
          (this.linearProtocolIds.length > 0 || this.nonlinearProtocolIds.length > 0) &&
          nonlinearSettingsValid
    },
  },
  methods: {
    toggleProfile(data) {
      this.streamProfileIds = processCheckboxListToggle(this.streamProfileIds, data)
    },
    getSubmitParams(){
      let nonlinearSettings = this._.pick(this.nonlinearSettings, ['has_timeshift', 'has_catchup', 'has_pvr'])
      if (this._.trim(this.nonlinearSettings.timeshift_override).length > 0) {
        nonlinearSettings['timeshift_override'] = this.nonlinearSettings.timeshift_override
      }
      if (this._.trim(this.nonlinearSettings.catchup_override).length > 0) {
        nonlinearSettings['catchup_override'] = this.nonlinearSettings.catchup_override
      }
      if (this._.trim(this.nonlinearSettings.pvr_override).length > 0) {
        nonlinearSettings['pvr_override'] = this.nonlinearSettings.pvr_override
      }

      return {
        linear_protocol_ids: this.linearProtocolIds,
        nonlinear_protocol_ids: this.nonlinearProtocolIds,
        stream_profile_ids: this.streamProfileIds,
        nonlinear_settings: nonlinearSettings,
        channel_ids: this.channels,
      }
    },
    submit() {
      this.setLoadingMessage()
      let params = this.getSubmitParams();

      this.contentSourceService.addComplexContent(this.$route.params.id, params)
          .then(() => {
            this.emptyMessage()
            this.$router.push({name: 'contentSourceDetail', params: {id: this.$route.params.id}})
          })
          .catch(error => {
            this.setErrorMessage(error['error_message'])
          })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/contentsources/content/ContentSourceContentNew.vue